<template>
    <v-card>
        <v-card-title>
            <v-btn icon small @click="close" color="primary">
                <v-icon>
                    mdi-close
                </v-icon>
            </v-btn>
            <h3 class="ml-2">Rejected</h3>
        </v-card-title>
        <v-card-text>
            <v-data-table
                :headers="headers"
                :items="items"
                class="elevation-0"
                :mobile-breakpoint="0"
                disable-pagination
                hide-default-footer
            >
                <template v-slot:[`item.date`]="{ item }">
                    <p class="my-0">{{ formatDate(item.date) }}</p>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</template>

<script>
import moment from 'moment'

export default {
    name: 'RejectionBOMTable',
    props: {
        items: {
            type: Array,
            required: true,
            default: () => [],
        },
    },
    data: () => ({
        headers: [
            {
                text: 'DATE',
                value: 'date',
                align: 'center',
                sortable: false,
            },
            {
                text: 'USER',
                value: 'user',
                align: 'left',
                sortable: false,
            },
            {
                text: 'NOTES',
                value: 'notes',
                align: 'left',
                sortable: false,
            },
        ],
    }),
    methods: {
        formatDate(date) {
            return moment
                .unix(date.seconds || date._seconds)
                .format('YYYY-MM-DD')
        },
        close() {
            this.$emit('closeDialog')
        },
    },
}
</script>

<style></style>
